var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"lg":"12"}},[_c('tab-programmatically')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }